<template>
  <div class="yxl-more" v-if="info">
    <div class="text" ref="text" :class="textClass">
      <div class="btn" @click="setShowAll">
        <span v-if="!showall && isMore && isShowMore">...<i>全部</i></span>
        <span v-else-if="showall && this.hiddenBtn">收起</span>
      </div>
      <div class="content" ref="content" v-html="info"></div>
    </div>
    <div
      :style="{ '-webkit-line-clamp': lineClamp }"
      class="text hide"
      ref="hide"
    >
      <p class="content" v-html="info"></p>
    </div>
  </div>
</template>

<script>
import { ResizeObserver } from '@juggle/resize-observer'

export default {
  name: 'yxlmore',
  props: {
    info: {
      type: String,
      default: ''
    },
    lineClamp: {
      type: Number,
      default: 3
    },
    isShowMore: {
      type: Boolean,
      default: true
    },
    hiddenBtn: {
      type: Boolean,
      default: true
    },
    isClickShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showall: false,
      isMore: false
    }
  },
  computed: {
    textStyleObject() {
      return {
        'max-height': this.showall ? 'none' : `${1.5 * this.lineClamp}em`
      }
    },
    textClass() {
      let cls = this.showall ? 'showall' : ''
      return cls
    }
  },
  watch: {
    info() {
      this.showall = false
    }
  },
  mounted() {
    this.setMore()
  },
  methods: {
    setShowAll() {
      if (!this.isClickShow) {
        this.$emit('btnClickCancel') // 可以自己在外边自定义点击事件
        return
      }
      this.showall = !this.showall
      this.$emit('setShowAllCallback', this.showall)
    },
    setMore() {
      if (this.$refs.content && this.$refs.hide && this.$refs.text) {
        const ro = new ResizeObserver((entries, observer) => {
          /**
           * 获取text赋值给hide，再比较两个内容的高度，如果hide比text高，则显示全部
           */
          this.$nextTick(() => {
            this.isMore =
              this.$refs.content.offsetHeight > this.$refs.hide.offsetHeight

            this.isMore &&
              (this.$refs.text.style.maxHeight = `${this.$refs.hide.clientHeight}px`)
          })
          observer.disconnect() // Stop observing
        })
        ro.observe(this.$refs.hide)
      }
    }
  }
}
</script>

<style lang="scss">
.yxl-more {
  position: relative;
  width: 100%;
  display: flex;
  overflow: hidden;
  line-height: 1.5;

  i {
    font-style: normal;
  }

  .text {
    width: 100%;
    position: relative;
    overflow: hidden;
    line-height: 1.5;
    text-align: justify;
    text-overflow: ellipsis;
    word-break: break-all;
    transition: 0.3s max-height;
    &.hide {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -99999;
      overflow: visible;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
  .text::before {
    float: right;
    height: calc(100% - 1em);
    content: '';
  }
  .btn {
    position: relative;
    float: right;
    clear: both;
    margin-left: 2px;
    line-height: 0.6;
    padding: 0 8px;
    color: #206ef7;
    border-radius: 4px;
    z-index: 10;
  }

  .text.showall {
    max-height: none !important;
  }
}
</style>
